module.exports = __webpack_public_path__ + "img/mianzhen.95315e64.png";